/* Plantlab — Home 2026. Comportamentos das secoes plantlab-* (carrosseis, abas,
   marquee, contagem regressiva e acordeoes). Sem dependencias.
   Cada init e idempotente e roda tambem no shopify:section:load do editor. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function once(el, flag) {
    if (!el || el.dataset[flag] === 'true') return false;
    el.dataset[flag] = 'true';
    return true;
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var items = root.querySelectorAll('.pl-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    items.forEach(function (el) {
      if (el.dataset.plRevealBound === 'true') return;
      el.dataset.plRevealBound = 'true';
      io.observe(el);
    });
  }

  // Video so baixa quando entra em cena. Sao arquivos de 3 a 5 MB e a home
  // tem dezenas deles (depoimentos, redes sociais e os clones dos carrosseis);
  // com todos baixando de saida, a pagina levava dezenas de segundos. Ate la o
  // que aparece e o poster, que ja vem no HTML.
  function initLazyVideos(root) {
    var videos = Array.prototype.slice.call(root.querySelectorAll('video[data-pl-lazy]'));
    if (!videos.length) return;

    function ligar(video) {
      if (video.dataset.plLazyOn === 'true') return;
      video.dataset.plLazyOn = 'true';

      // O poster tambem espera: sao 14 imagens de ~100 KB so nas secoes de
      // video. Como ele chega muito antes do arquivo de video, continua
      // cobrindo o intervalo ate o primeiro quadro aparecer.
      if (video.dataset.plPoster) {
        video.setAttribute('poster', video.dataset.plPoster);
        delete video.dataset.plPoster;
      }

      // O video_tag da Shopify tambem embute um <img> de fallback, que baixava
      // a mesma imagem do poster mesmo sem nunca aparecer.
      var achou = false;
      video.querySelectorAll('[data-pl-src]').forEach(function (node) {
        node.setAttribute('src', node.getAttribute('data-pl-src'));
        node.removeAttribute('data-pl-src');
        if (node.tagName === 'SOURCE') achou = true;
      });
      if (!achou) return;
      video.load();
      tocar(video);
    }

    function tocar(video) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(ligar);
      return;
    }

    // A margem generosa da tempo de o arquivo comecar a chegar antes de o card
    // aparecer, sem antecipar a secao inteira.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          ligar(entry.target);
          tocar(entry.target);
        } else if (entry.target.dataset.plLazyOn === 'true') {
          entry.target.pause();
        }
      });
    }, { rootMargin: '300px 0px', threshold: 0.01 });

    videos.forEach(function (video) {
      if (video.dataset.plLazyBound === 'true') return;
      video.dataset.plLazyBound = 'true';
      io.observe(video);
    });
  }

  /* ---------- Rotador generico de slides (classe is-active) ---------- */
  function createRotator(options) {
    var slides = options.slides;
    var index = 0;
    var timer = null;

    function delayFor(i) {
      var custom = slides[i] && slides[i].dataset.plDelay;
      return parseInt(custom, 10) || options.interval || 5000;
    }

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      if (options.onChange) options.onChange(index);
      schedule();
    }

    function schedule() {
      window.clearTimeout(timer);
      if (options.interval === 0 || slides.length < 2 || options.paused) return;
      timer = window.setTimeout(function () { show(index + 1); }, delayFor(index));
    }

    function pause(state) {
      options.paused = state;
      if (state) window.clearTimeout(timer); else schedule();
    }

    show(0);

    return {
      show: show,
      next: function () { show(index + 1); },
      prev: function () { show(index - 1); },
      pause: pause,
      current: function () { return index; }
    };
  }

  function buildDots(container, count, onPick) {
    if (!container || count < 2) {
      if (container) container.innerHTML = '';
      return function () {};
    }

    container.innerHTML = '';
    var buttons = [];
    for (var i = 0; i < count; i++) {
      (function (i) {
        var b = document.createElement('button');
        b.type = 'button';
        // O tema esconde elementos vazios (*:empty em base.css); display-empty e a
        // classe de escape que o proprio tema define para casos como este.
        b.className = 'display-empty';
        b.setAttribute('aria-label', 'Ir para o item ' + (i + 1));
        b.addEventListener('click', function () { onPick(i); });
        container.appendChild(b);
        buttons.push(b);
      })(i);
    }

    return function (active) {
      buttons.forEach(function (b, i) {
        b.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    };
  }


  // Troca de slide pelo gesto de arrastar o dedo. O alvo recebe
  // touch-action: pan-y no CSS, entao o navegador continua rolando a pagina na
  // vertical e so o movimento lateral chega ate aqui. Mouse fica de fora: no
  // desktop as setas e os dots ja resolvem.
  function enableSwipe(target, handlers) {
    if (!target || !window.PointerEvent) return;

    var MIN_TRAVEL = 40; // px para valer a troca
    var LOCK_AXIS = 10;  // px para decidir que o gesto e horizontal
    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var tracking = false;
    var horizontal = false;

    // Um arrasto sobre o banner nao pode virar clique no link. O bloqueio vale
    // so pelo instante em que o clique sintetico chegaria; sem esse prazo, ele
    // sobraria pendurado e comeria o proximo toque de verdade.
    function swallowNextClick() {
      function block(event) {
        event.preventDefault();
        event.stopPropagation();
        release();
      }
      function release() {
        target.removeEventListener('click', block, true);
      }
      target.addEventListener('click', block, true);
      window.setTimeout(release, 350);
    }

    function finish(dx) {
      if (!tracking) return;
      var enough = horizontal && Math.abs(dx) >= MIN_TRAVEL;
      tracking = false;
      horizontal = false;
      if (enough) {
        if (dx < 0) handlers.onNext(); else handlers.onPrev();
        swallowNextClick();
      }
      if (handlers.onEnd) handlers.onEnd();
    }

    target.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' || !event.isPrimary) return;
      tracking = true;
      horizontal = false;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      if (handlers.onStart) handlers.onStart();
    }, { passive: true });

    target.addEventListener('pointermove', function (event) {
      if (!tracking) return;
      lastX = event.clientX;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (!horizontal && Math.abs(dx) > LOCK_AXIS && Math.abs(dx) > Math.abs(dy)) {
        horizontal = true;
      }
      if (horizontal && event.cancelable) event.preventDefault();
    });

    // O fim do gesto vem do window: o dedo costuma soltar fora da faixa, e
    // capturar o ponteiro no elemento mudaria o alvo do clique dos botoes.
    window.addEventListener('pointerup', function (event) {
      finish(event.clientX - startX);
    });

    // O Safari cancela o ponteiro assim que decide que o gesto virou rolagem.
    // O ultimo ponto visto ainda vale: se o dedo ja tinha andado o bastante na
    // horizontal, a troca acontece do mesmo jeito.
    window.addEventListener('pointercancel', function () {
      finish(lastX - startX);
    });
  }

  /* ---------- 1. Barra de aviso ---------- */
  function initAnnounce(root) {
    if (!once(root, 'plAnnounce')) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pl-announce-slide]'));
    if (!slides.length) return;

    slides.forEach(function (slide) {
      slide.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-pl-coupon]');
        if (!chip) return;
        var code = chip.dataset.plCoupon || '';
        var label = chip.querySelector('[data-pl-coupon-label]');
        var original = label ? label.textContent : '';

        function done() {
          if (!label) return;
          label.textContent = chip.dataset.plCouponCopied || 'CUPOM COPIADO!';
          window.setTimeout(function () { label.textContent = original; }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    });

    function paintTheme(i) {
      var slide = slides[i];
      root.style.setProperty('--pl-announce-bg', slide.dataset.plBg || '');
      root.style.setProperty('--pl-announce-fg', slide.dataset.plFg || '');
      slide.classList.add('pl-slidein');
      window.setTimeout(function () { slide.classList.remove('pl-slidein'); }, 600);
    }

    // No mobile a barra tem altura fixa de uma linha. Quando o texto do painel
    // e mais largo que a tela, em vez de quebrar a linha ele desliza de um lado
    // ao outro (vai-e-volta), mantendo a frase inteira legivel.
    var slidesBox = root.querySelector('.pl-announce__slides');

    var interval = parseInt(root.dataset.plInterval, 10) || 12000;
    var MARQUEE_SPEED = 32; // px por segundo — ritmo de leitura confortavel
    var MARQUEE_GAP = 48;   // respiro entre uma volta e outra

    // No mobile o texto que nao cabe vira um ticker: duas copias lado a lado
    // rodando em loop continuo, sem ir-e-voltar e sem comecar cortado.
    function buildMarquee(slide) {
      if (slide.dataset.plMarquee === 'true') return;
      slide.dataset.plMarquee = 'true';

      var group = document.createElement('span');
      group.className = 'pl-announce__group';
      while (slide.firstChild) group.appendChild(slide.firstChild);

      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a, button').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });

      var track = document.createElement('span');
      track.className = 'pl-announce__marquee';
      track.appendChild(group);
      track.appendChild(clone);
      slide.appendChild(track);
    }

    function fitSlide(slide) {
      if (!slide || !slidesBox) return;
      buildMarquee(slide);

      var group = slide.querySelector('.pl-announce__group');
      slide.classList.remove('is-marquee');
      slide.style.removeProperty('--pl-announce-loop');
      slide.style.removeProperty('--pl-announce-duration');

      if (!isMobile() || !group) {
        root.classList.remove('has-overflow');
        delete slide.dataset.plDelay;
        return;
      }

      var groupWidth = Math.ceil(group.getBoundingClientRect().width);
      if (groupWidth <= slidesBox.clientWidth + 1) {
        root.classList.remove('has-overflow');
        delete slide.dataset.plDelay;
        return;
      }

      var loop = groupWidth + MARQUEE_GAP;
      var lap = (loop / MARQUEE_SPEED) * 1000;
      slide.style.setProperty('--pl-announce-loop', loop + 'px');
      slide.style.setProperty('--pl-announce-duration', (lap / 1000).toFixed(1) + 's');
      // O aviso so troca depois de uma volta completa: ninguem perde o fim da
      // frase porque o slide mudou no meio.
      slide.dataset.plDelay = Math.round(Math.max(interval, lap));
      root.classList.add('has-overflow');
      slide.classList.add('is-marquee');
    }

    function fitActive() {
      fitSlide(slides.filter(function (s) { return s.classList.contains('is-active'); })[0]);
    }

    var rotator = createRotator({
      slides: slides,
      interval: interval,
      onChange: function (i) {
        paintTheme(i);
        fitSlide(slides[i]);
      }
    });

    window.addEventListener('resize', fitActive);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitActive);
    fitActive();

    root.addEventListener('mouseenter', function () { rotator.pause(true); });
    root.addEventListener('mouseleave', function () { rotator.pause(false); });

    root.querySelectorAll('[data-pl-announce-prev]').forEach(function (b) {
      b.addEventListener('click', rotator.prev);
    });
    root.querySelectorAll('[data-pl-announce-next]').forEach(function (b) {
      b.addEventListener('click', rotator.next);
    });

    startCountdowns(root);
  }

  function startCountdowns(root) {
    root.querySelectorAll('[data-pl-countdown]').forEach(function (el) {
      if (el.dataset.plCountdownBound === 'true') return;
      el.dataset.plCountdownBound = 'true';

      // "2026-08-31 23:59" so e aceito por alguns navegadores; a forma com "T"
      // e a padronizada pelo ECMAScript.
      var raw = (el.dataset.plCountdown || '').trim();
      var target = Date.parse(raw.replace(' ', 'T'));
      if (isNaN(target)) target = Date.parse(raw);
      if (isNaN(target)) {
        var hours = parseFloat(el.dataset.plCountdownHours);
        if (!isNaN(hours)) target = Date.now() + hours * 3600 * 1000;
      }
      if (isNaN(target)) return;

      var parts = {
        d: el.querySelector('[data-pl-cd="d"]'),
        h: el.querySelector('[data-pl-cd="h"]'),
        m: el.querySelector('[data-pl-cd="m"]'),
        s: el.querySelector('[data-pl-cd="s"]')
      };

      function pad(n) { return String(n).padStart(2, '0'); }

      function tick() {
        var left = Math.max(0, Math.floor((target - Date.now()) / 1000));
        if (parts.d) parts.d.textContent = pad(Math.floor(left / 86400)) + 'D';
        if (parts.h) parts.h.textContent = pad(Math.floor(left / 3600) % 24) + 'H';
        if (parts.m) parts.m.textContent = pad(Math.floor(left / 60) % 60) + 'M';
        if (parts.s) parts.s.textContent = pad(left % 60) + 'S';
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  /* ---------- 2. Hero ---------- */
  function initHero(root) {
    if (!once(root, 'plHero')) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pl-hero-slide]'));
    if (!slides.length) return;

    var dotsBox = root.querySelector('[data-pl-hero-dots]');
    var paint = buildDots(dotsBox, slides.length, function (i) { rotator.show(i); });

    var rotator = createRotator({
      slides: slides,
      interval: parseInt(root.dataset.plInterval, 10) || 7000,
      onChange: function (i) {
        paint(i);
        replayAnimations(slides[i]);
        playVideos(slides[i], slides);
      }
    });

    root.querySelectorAll('[data-pl-hero-prev]').forEach(function (b) {
      b.addEventListener('click', rotator.prev);
    });
    root.querySelectorAll('[data-pl-hero-next]').forEach(function (b) {
      b.addEventListener('click', rotator.next);
    });

    // No toque, arrastar para o lado troca o banner. A rotacao automatica fica
    // parada enquanto o dedo esta na tela e volta a contar ao soltar.
    enableSwipe(root, {
      onStart: function () { rotator.pause(true); },
      onEnd: function () { rotator.pause(false); },
      onNext: rotator.next,
      onPrev: rotator.prev
    });
  }

  function replayAnimations(slide) {
    slide.querySelectorAll('.pl-up, .pl-packin, .pl-fadein').forEach(function (el) {
      var animations = ['pl-up', 'pl-packin', 'pl-fadein'].filter(function (c) {
        return el.classList.contains(c);
      });
      animations.forEach(function (c) { el.classList.remove(c); });
      void el.offsetWidth;
      animations.forEach(function (c) { el.classList.add(c); });
    });
  }

  function playVideos(active, all) {
    all.forEach(function (slide) {
      slide.querySelectorAll('video').forEach(function (video) {
        if (slide === active) {
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          video.pause();
        }
      });
    });
  }

  /* ---------- 3. Mais vendidos (abas + paginacao) ---------- */
  function initBestSellers(root) {
    if (!once(root, 'plBest')) return;

    var PER_PAGE = 4;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pl-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pl-panel]'));
    var nav = root.querySelector('[data-pl-best-nav]');
    var dotsBox = root.querySelector('[data-pl-best-dots]');
    var dots = { count: 0, paint: function () {} };

    function activePanel() {
      return panels.filter(function (p) { return !p.hidden; })[0];
    }

    // Cada aba vira um carrossel infinito: tres copias da lista, a do meio e a
    // real. Ao passar do fim (ou do inicio) o track volta uma copia inteira sem
    // animacao, entao o giro nunca "rebobina" na frente do usuario.
    function setup(panel) {
      if (panel.dataset.plLoopReady === 'true') return;
      panel.dataset.plLoopReady = 'true';

      var track = panel.querySelector('[data-pl-best-track]');
      if (!track) return;

      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;

      // Uma aba que cabe inteira numa pagina nao tem para onde girar. Clonar
      // ali faria o mesmo produto aparecer repetido lado a lado, como se a
      // colecao tivesse mais itens do que tem.
      if (originals.length <= PER_PAGE) {
        panel.plLoop = { track: track, count: originals.length, index: 0, busy: false, looping: false };
        return;
      }

      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();

      originals.forEach(function (node) {
        [beforeFrag, afterFrag].forEach(function (frag) {
          var clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-pl-clone', 'true');
          clone.removeAttribute('id');
          clone.querySelectorAll('a, button').forEach(function (el) {
            el.setAttribute('tabindex', '-1');
          });
          frag.appendChild(clone);
        });
      });

      track.insertBefore(beforeFrag, track.firstChild);
      track.appendChild(afterFrag);

      panel.plLoop = { track: track, count: originals.length, index: 0, busy: false, looping: true };

      track.addEventListener('transitionend', function (event) {
        if (event.target !== track || event.propertyName !== 'transform') return;
        var loop = panel.plLoop;
        loop.busy = false;
        if (loop.index >= loop.count) {
          loop.index -= loop.count;
          apply(panel, false);
        } else if (loop.index < 0) {
          loop.index += loop.count;
          apply(panel, false);
        }
      });
    }

    function step(panel) {
      var card = panel.querySelector('.pl-pcard');
      if (!card) return 0;
      var track = panel.plLoop.track;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function apply(panel, animate) {
      var loop = panel.plLoop;
      if (!loop) return;
      // No mobile o carrossel e o scroll nativo com snap; transform atrapalha.
      if (isMobile()) {
        loop.track.style.transform = '';
        return;
      }
      // Aba sem giro: os cards ficam onde estao.
      if (!loop.looping) {
        loop.track.style.transform = '';
        paintDots(panel);
        return;
      }
      loop.track.classList.toggle('is-jumping', !animate);
      loop.track.style.transform = 'translateX(' + (-(loop.index + loop.count) * step(panel)) + 'px)';
      if (!animate) {
        void loop.track.offsetWidth;
        loop.track.classList.remove('is-jumping');
      }
      paintDots(panel);
    }

    function pageCount(panel) {
      return Math.max(1, Math.ceil(panel.plLoop.count / PER_PAGE));
    }

    function currentPage(panel) {
      var loop = panel.plLoop;
      var card = ((loop.index % loop.count) + loop.count) % loop.count;
      return Math.min(pageCount(panel) - 1, Math.floor(card / PER_PAGE));
    }

    function paintDots(panel) {
      if (!dotsBox) return;
      var pages = pageCount(panel);
      if (dots.count !== pages) {
        dots.paint = buildDots(dotsBox, pages, function (i) {
          var panelNow = activePanel();
          if (panelNow) move(panelNow, i * PER_PAGE - panelNow.plLoop.index);
        });
        dots.count = pages;
      }
      dotsBox.hidden = pages < 2 || isMobile();
      dots.paint(currentPage(panel));
    }

    function move(panel, deltaCards) {
      var loop = panel.plLoop;
      if (!loop || !loop.looping || loop.busy || isMobile() || !deltaCards) return;
      loop.busy = true;
      loop.index += deltaCards;
      apply(panel, true);
    }

    function render() {
      var panel = activePanel();
      if (!panel) return;
      setup(panel);
      if (!panel.plLoop) return;
      if (nav) nav.hidden = pageCount(panel) < 2 || isMobile();
      apply(panel, false);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', String(t === tab));
        });
        panels.forEach(function (panel) {
          var match = panel.dataset.plPanel === tab.dataset.plTab;
          panel.hidden = !match;
          if (match) {
            setup(panel);
            if (panel.plLoop) {
              panel.plLoop.index = 0;
              panel.plLoop.busy = false;
            }
            panel.classList.remove('pl-fadein');
            void panel.offsetWidth;
            panel.classList.add('pl-fadein');
          }
        });
        render();
        initReveal(root);
      });
    });

    root.querySelectorAll('[data-pl-best-prev]').forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = activePanel();
        if (panel) move(panel, -PER_PAGE);
      });
    });
    root.querySelectorAll('[data-pl-best-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        var panel = activePanel();
        if (panel) move(panel, PER_PAGE);
      });
    });

    window.addEventListener('resize', render);
    panels.forEach(setup);
    render();
  }

  /* ---------- Carrossel de loop infinito (descontos e social) ---------- */
  function initLoopCarousel(root, config) {
    if (!once(root, config.flag)) return;

    var track = root.querySelector(config.track);
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    var count = originals.length;
    if (!count) return;

    var dotsBox = config.dots ? root.querySelector(config.dots) : null;
    var paint = buildDots(dotsBox, count, function (i) { goTo(i); });
    var index = 0;
    var busy = false;
    var timer = null;
    var hovering = false;

    // Tres copias da lista: a do meio e a "real", as laterais cobrem o loop.
    // Os clones entram por fragmento para preservar a ordem original.
    var beforeFrag = document.createDocumentFragment();
    var afterFrag = document.createDocumentFragment();
    originals.forEach(function (node) {
      var before = node.cloneNode(true);
      var after = node.cloneNode(true);
      before.setAttribute('aria-hidden', 'true');
      after.setAttribute('aria-hidden', 'true');
      before.removeAttribute('id');
      after.removeAttribute('id');
      beforeFrag.appendChild(before);
      afterFrag.appendChild(after);
    });
    track.insertBefore(beforeFrag, track.firstChild);
    track.appendChild(afterFrag);

    function step() {
      var first = originals[0];
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function apply(animate) {
      track.classList.toggle('is-jumping', !animate);
      track.style.transform = 'translateX(' + (-(index + count) * step()) + 'px)';
      if (!animate) {
        void track.offsetWidth;
        track.classList.remove('is-jumping');
      }
      paint(((index % count) + count) % count);
    }

    function move(delta) {
      if (busy || isMobile()) return;
      busy = true;
      index += delta;
      apply(true);
    }

    function goTo(target) {
      if (busy || isMobile()) return;
      var current = ((index % count) + count) % count;
      move(target - current);
    }

    track.addEventListener('transitionend', function (event) {
      if (event.target !== track || event.propertyName !== 'transform') return;
      busy = false;
      if (index >= count) { index -= count; apply(false); }
      else if (index < 0) { index += count; apply(false); }
    });

    function schedule() {
      window.clearInterval(timer);
      if (!config.interval) return;
      timer = window.setInterval(function () {
        if (hovering || isMobile() || document.hidden) return;
        move(1);
      }, config.interval);
    }

    root.querySelectorAll(config.prev).forEach(function (b) {
      b.addEventListener('click', function () { move(-1); });
    });
    root.querySelectorAll(config.next).forEach(function (b) {
      b.addEventListener('click', function () { move(1); });
    });

    var hoverTarget = root.querySelector(config.hover || config.track) || track;
    hoverTarget.addEventListener('mouseenter', function () { hovering = true; });
    hoverTarget.addEventListener('mouseleave', function () { hovering = false; });

    window.addEventListener('resize', function () { apply(false); });

    apply(false);
    schedule();
  }

  /* ---------- 5. Diferenciais ---------- */
  function initDiff(root) {
    if (!once(root, 'plDiff')) return;

    var marquee = root.querySelector('[data-pl-marquee]');
    var drawer = root.querySelector('[data-pl-diff-drawer]');
    var titleEl = root.querySelector('[data-pl-diff-out-title]');
    var textEl = root.querySelector('[data-pl-diff-out-text]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pl-diff-item]'));
    var openKey = null;
    var touchTimer = null;

    function paintPause() {
      if (!marquee) return;
      marquee.classList.toggle('is-paused', root.dataset.plHover === 'true' || openKey !== null);
    }

    function close() {
      openKey = null;
      items.forEach(function (item) { item.setAttribute('aria-expanded', 'false'); });
      if (drawer) drawer.classList.remove('is-open');
      paintPause();
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var key = item.dataset.plDiffItem;
        if (openKey === key) { close(); return; }
        openKey = key;
        items.forEach(function (other) {
          other.setAttribute('aria-expanded', String(other.dataset.plDiffItem === key));
        });
        if (titleEl) titleEl.textContent = item.dataset.plDiffTitle || '';
        if (textEl) textEl.textContent = item.dataset.plDiffText || '';
        if (drawer) drawer.classList.add('is-open');
        paintPause();
      });
    });

    root.querySelectorAll('[data-pl-diff-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    if (marquee) {
      var wrap = marquee.parentNode;
      wrap.addEventListener('mouseenter', function () {
        root.dataset.plHover = 'true';
        paintPause();
      });
      wrap.addEventListener('mouseleave', function () {
        root.dataset.plHover = 'false';
        paintPause();
      });
      wrap.addEventListener('touchstart', function () {
        root.dataset.plHover = 'true';
        paintPause();
        window.clearTimeout(touchTimer);
        touchTimer = window.setTimeout(function () {
          root.dataset.plHover = 'false';
          paintPause();
        }, 3500);
      }, { passive: true });
    }
  }

  /* ---------- 6. Depoimentos ---------- */
  function initReviews(root) {
    if (!once(root, 'plRevs')) return;

    var track = root.querySelector('[data-pl-revs-track]');
    if (!track) return;

    var cards = track.querySelectorAll('.pl-rev');
    var page = 0;

    function maxPage() {
      var visible = Math.max(1, Math.floor(track.parentNode.clientWidth / cards[0].getBoundingClientRect().width));
      return Math.max(0, cards.length - visible);
    }

    function render() {
      if (isMobile() || !cards.length) return;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var step = cards[0].getBoundingClientRect().width + gap;
      var limit = maxPage();
      page = Math.min(Math.max(0, page), limit);
      track.style.transform = 'translateX(' + (-page * step) + 'px)';
    }

    root.querySelectorAll('[data-pl-revs-prev]').forEach(function (b) {
      b.addEventListener('click', function () {
        page = page <= 0 ? maxPage() : page - 1;
        render();
      });
    });
    root.querySelectorAll('[data-pl-revs-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        page = page >= maxPage() ? 0 : page + 1;
        render();
      });
    });

    window.addEventListener('resize', render);
    render();
  }

  /* ---------- 8. Footer ---------- */
  function initFooter(root) {
    if (!once(root, 'plFoot')) return;

    root.querySelectorAll('[data-pl-foot-top]').forEach(function (b) {
      b.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    root.querySelectorAll('[data-pl-foot-acc]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        var open = button.getAttribute('aria-expanded') === 'true';

        root.querySelectorAll('[data-pl-foot-acc]').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.classList.remove('is-open');
        });

        if (!open) {
          button.setAttribute('aria-expanded', 'true');
          if (panel) panel.classList.add('is-open');
        }
      });
    });
  }

  /* ---------- Bootstrap ---------- */
  function initAll(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-pl-announce]').forEach(initAnnounce);
    root.querySelectorAll('[data-pl-hero]').forEach(initHero);
    root.querySelectorAll('[data-pl-best]').forEach(initBestSellers);
    root.querySelectorAll('[data-pl-promos]').forEach(function (el) {
      initLoopCarousel(el, {
        flag: 'plPromos',
        track: '[data-pl-promos-track]',
        dots: '[data-pl-promos-dots]',
        prev: '[data-pl-promos-prev]',
        next: '[data-pl-promos-next]',
        hover: '[data-pl-promos-viewport]',
        interval: parseInt(el.dataset.plInterval, 10) || 0
      });
    });
    root.querySelectorAll('[data-pl-diff]').forEach(initDiff);
    root.querySelectorAll('[data-pl-revs]').forEach(initReviews);
    root.querySelectorAll('[data-pl-social]').forEach(function (el) {
      initLoopCarousel(el, {
        flag: 'plSocial',
        track: '[data-pl-social-track]',
        prev: '[data-pl-social-prev]',
        next: '[data-pl-social-next]',
        hover: '[data-pl-social-viewport]',
        interval: 0
      });
    });
    root.querySelectorAll('[data-pl-foot]').forEach(initFooter);

    initReveal(root === document ? document.body : root);
    initLazyVideos(root === document ? document.body : root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
